module.exports = __WEBPACK_EXTERNAL_MODULE_http_localhost_4202_remoteEntry_mjs_0a529f60__;